import type { CustomJsonComponentConfig } from '@apps/websiteCustomJsonComponents/config';
import { createLazyComponentFromNamedExport } from '@shared/utils/createLazyComponent';
import { FaqGrabber } from './FaqSidebar';

// Lazy load view components
const FaqAdd = createLazyComponentFromNamedExport(() => import(/* webpackChunkName: "content/websiteEditorFaqAdd" */ './FaqSidebar'), 'FaqAdd');

const FaqEdit = createLazyComponentFromNamedExport(() => import(/* webpackChunkName: "content/websiteEditorFaqEdit" */ './components/FaqEdit'), 'FaqEdit');

const FaqGuest = createLazyComponentFromNamedExport(() => import(/* webpackChunkName: "content/websiteEditorFaqGuest" */ './components/FaqGuest'), 'FaqGuest');

// Add this object to CUSTOM_JSON_COMPONENT_TYPES in
// src/apps/websiteCustomJsonComponents/config.ts
export const FaqConfig: CustomJsonComponentConfig = {
  schemaUrl: 'https://withjoy.com/assets/public/schemas/faqSchemaV1_0_1.json',
  componentType: 'Faq',
  adminSidebarComponent: {
    addComponentView: FaqAdd,
    dragComponentView: FaqGrabber,
    editComponentView: FaqEdit,
    createComponentView: FaqEdit,
  },
  guestSiteComponent: FaqGuest,
};
